var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeadCondensed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.9 31.3",
    style: {
      enableBackground: "new 0 0 52.9 31.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#47B59E;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo+claim") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-662.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(662.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.4,26.9c0.9,0.9,1.8,1.7,2.9,2.4c2.4,1.4,5.1,2.1,7.9,2.1c2.7,0,5.4-0.7,7.7-2.1c2.2-1.3,4-3.3,5.2-5.6 c1.3-2.5,1.9-5.3,1.8-8.1c0-2.7-0.6-5.4-1.7-7.9c-1.1-2.3-2.9-4.2-5.1-5.6C43.7,0.6,41-0.1,38.2,0C20.1,0,26.9,26.5,14.7,26.5 c-1.6,0-3.3-0.4-4.6-1.3c-1.4-0.9-2.4-2.3-3-3.8c-0.7-1.8-1.1-3.7-1.1-5.6c0-2,0.4-3.9,1.2-5.7C7.9,8.5,9,7.2,10.4,6.2 c1.3-0.9,2.8-1.4,4.4-1.3c1.6,0,3.2,0.4,4.6,1.4c1.4,1,2.4,2.3,3,3.8c0.1,0.2,0.2,0.5,0.3,0.7c0.7-2.2,1.6-4.4,2.6-6.5 c-0.8-0.8-1.7-1.6-2.7-2.2c-2.4-1.4-5.1-2.1-7.9-2.1C12,0,9.4,0.7,7,2.1C4.8,3.5,3,5.4,1.8,7.7C0.6,10.2,0,13,0,15.8 c0,2.7,0.6,5.4,1.7,7.9c1.1,2.3,2.9,4.2,5.1,5.6c2.4,1.4,5.1,2.1,7.9,2.1c17.9,0,11-26.5,23.5-26.5c1.6,0,3.3,0.4,4.6,1.3 c1.4,0.9,2.4,2.3,3,3.8c0.7,1.8,1.1,3.7,1.1,5.6c0,2-0.4,3.9-1.2,5.7c-0.7,1.5-1.8,2.9-3.2,3.8c-1.3,0.9-2.8,1.4-4.4,1.3 c-1.6,0-3.2-0.4-4.6-1.4c-1.4-1-2.4-2.3-3-3.8c-0.2-0.4-0.3-0.7-0.4-1.1C29.3,22.5,28.4,24.7,27.4,26.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeadCondensed);
export default __webpack_public_path__ + "static/media/logo-head-condensed.ceee9499d93c5841c2925ccfea2716aa.svg";
export { ForwardRef as ReactComponent };